import { render, staticRenderFns } from "./DraggableField.vue?vue&type=template&id=82524ff4&scoped=true&"
import script from "./DraggableField.vue?vue&type=script&lang=js&"
export * from "./DraggableField.vue?vue&type=script&lang=js&"
import style0 from "./DraggableField.vue?vue&type=style&index=0&id=82524ff4&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "82524ff4",
  null
  
)

/* hot reload */
if (module.hot) {
  var api = require("/codebuild/output/src1477836768/src/github.com/FebosIO/Febos-AMI/node_modules/vue-hot-reload-api/dist/index.js")
  api.install(require('vue'))
  if (api.compatible) {
    module.hot.accept()
    if (!api.isRecorded('82524ff4')) {
      api.createRecord('82524ff4', component.options)
    } else {
      api.reload('82524ff4', component.options)
    }
    module.hot.accept("./DraggableField.vue?vue&type=template&id=82524ff4&scoped=true&", function () {
      api.rerender('82524ff4', {
        render: render,
        staticRenderFns: staticRenderFns
      })
    })
  }
}
component.options.__file = "src/febos/global/pdf/formBuilder/components/DraggableField.vue"
export default component.exports